import { useCallback, useState } from 'react';
import { loadCustomerLocation, requestCustomerLocation } from '../lib/customerLocation';

export default function useCustomerLocation() {
  const [coords, setCoords] = useState(() => loadCustomerLocation());
  const [status, setStatus] = useState(() => (loadCustomerLocation() ? 'granted' : 'idle'));
  const [requesting, setRequesting] = useState(false);

  const requestLocation = useCallback(async () => {
    setRequesting(true);
    try {
      const next = await requestCustomerLocation();
      setCoords(next);
      setStatus('granted');
      return next;
    } catch (error) {
      setStatus(error?.code === 1 || error?.code === 'denied' ? 'denied' : 'unavailable');
      throw error;
    } finally {
      setRequesting(false);
    }
  }, []);

  return { coords, status, requesting, requestLocation };
}
